import type { CSSProperties } from 'react';

export interface Layout4ThemeColors {
  header: string;
  menu: string;
  primary: string;
  secondary: string;
  button: string;
  title: string;
  text: string;
}

/** CSS variables for layout-4 — mirrors themeColors from config (layouts 1/2 pattern). */
export function layout4ThemeStyle(colors: Layout4ThemeColors): CSSProperties {
  return {
    '--wl4-accent': colors.button,
    '--wl4-primary': colors.primary,
    '--wl4-secondary': colors.secondary,
    '--wl4-header-bg': colors.header,
    '--wl4-menu': colors.menu,
    '--wl4-title': colors.title,
    '--wl4-text': colors.text,
    '--wl4-dark': colors.primary,
    '--wl4-topbar-bg': colors.menu,
    '--wl4-topbar-text': colors.header,
    '--wl4-footer-bg': colors.primary,
    '--l4-accent': colors.button,
  } as CSSProperties;
}
